/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dark_ModeInputs */

const en_mobile_dark_mode = /** @type {(inputs: Mobile_Dark_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark Mode`)
};

const es_mobile_dark_mode = /** @type {(inputs: Mobile_Dark_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo oscuro`)
};

/**
* | output |
* | --- |
* | "Dark Mode" |
*
* @param {Mobile_Dark_ModeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dark_mode = /** @type {((inputs?: Mobile_Dark_ModeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dark_ModeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dark_mode(inputs)
	return en_mobile_dark_mode(inputs)
});